import { makeStyles } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { useAnswerContext } from './context';
import { Footer, Intro, Result, Survey, Contact, MainFrom } from './pages';
import { useQueryParam } from 'use-query-params';
import { Route } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  backdrop: {
    width: '100%',
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    left: 0,
    background: '#F8F9FA',
    [theme.breakpoints.down('md')]: {
      top: 900,
    },
    [theme.breakpoints.up('md')]: {
      top: 800,
    },
  },
}));

export const App = () => {
  const classes = useStyles();
  const { isComplete, showResult } = useAnswerContext();
  const backRef = useRef<HTMLDivElement>(null);
  const [utm_source] = useQueryParam<string>('utm_source');
  const [utm_campaign] = useQueryParam<string>('utm_campaign');
  const [utm_medium] = useQueryParam<string>('utm_medium');
  const [utm_content] = useQueryParam<string>('utm_content');

  useEffect(() => {
    if (utm_campaign) {
      sessionStorage.setItem('utm_campaign', utm_campaign);
    }
    if (utm_campaign) {
      sessionStorage.setItem('utm_campaign', utm_campaign);
    }
    if (utm_medium) {
      sessionStorage.setItem('utm_medium', utm_medium);
    }
    if (utm_content) {
      sessionStorage.setItem('utm_content', utm_content);
    }
  }, [utm_campaign, utm_content, utm_medium, utm_source]);

  useEffect(() => {
    if (backRef.current) {
      backRef.current.style.height = document.body.clientHeight - 1000 + 'px';
    }
  });

  return (
    <Route path="*">
      <div className={classes.root}>
        {!isComplete ? <Intro /> : null}
        {!isComplete ? <Survey /> : null}
        {isComplete && showResult ? <Result /> : null}
        {isComplete && !showResult ? <MainFrom /> : null}
      </div>
      {isComplete && showResult ? <Contact /> : null}
      {isComplete && showResult ? (
        <div ref={backRef} className={classes.backdrop}></div>
      ) : null}
      <Footer />
    </Route>
  );
};
